import { createApp } from 'vue'
import App from './App.vue'
import './assets/index.css'
import ElementUI from 'element-plus'
import 'element-plus/dist/index.css'
import 'element-plus/theme-chalk/dark/css-vars.css'

const app = createApp(App)
app.use(ElementUI);
app.mount('#app')
